module.exports = __webpack_public_path__ + "static/media/SG-SNI4_1OtwbUipI5wa_2x56RFvo-jYp6wyrOquA.3dbf6b49.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photos/SG-SNI4_1OtwbUipI5wa_2x56RFvo-jYp6wyrOquA
// module id = 672
// module chunks = 0